{
  "CompatibleAtlassianProduct": [
    "CompatibleAtlassianCloudProduct",
    "CompatibleAtlassianDataCenterProduct",
    "CompatibleAtlassianServerProduct"
  ],
  "MarketplaceAppDeployment": [
    "MarketplaceCloudAppDeployment",
    "MarketplaceConnectAppDeployment",
    "MarketplaceInstructionalAppDeployment",
    "MarketplacePlugins1AppDeployment",
    "MarketplacePlugins2AppDeployment",
    "MarketplaceWorkflowAppDeployment"
  ],
  "MarketplaceAppTrustInformationResult": [
    "MarketplaceAppTrustInformation",
    "QueryError"
  ],
  "MarketplaceConsoleCreatePrivateAppVersionMutationOutput": [
    "MarketplaceConsoleCreatePrivateAppVersionKnownError",
    "MarketplaceConsoleCreatePrivateAppVersionMutationResponse"
  ],
  "MarketplaceConsoleDeleteAppVersionResponse": [
    "MarketplaceConsoleKnownError",
    "MarketplaceConsoleMutationVoidResponse"
  ],
  "MarketplaceConsoleEditionResponse": [
    "MarketplaceConsoleEdition",
    "MarketplaceConsoleEditionPricingKnownError"
  ],
  "MarketplaceConsoleEditionsActivationResponse": [
    "MarketplaceConsoleEditionsActivation",
    "MarketplaceConsoleKnownError"
  ],
  "MarketplaceConsoleError": [
    "MarketplaceConsoleCreatePrivateAppVersionError",
    "MarketplaceConsoleEditionPricingKnownError",
    "MarketplaceConsoleGenericError",
    "MarketplaceConsoleKnownError",
    "MarketplaceConsoleMakeAppPublicError"
  ],
  "MarketplaceConsoleMakeAppVersionPublicMutationOutput": [
    "MarketplaceConsoleMakeAppPublicKnownError",
    "MarketplaceConsoleMutationVoidResponse"
  ],
  "MarketplaceStoreCurrentUserResponse": [
    "MarketplaceStoreAnonymousUser",
    "MarketplaceStoreLoggedInUser"
  ],
  "MarketplaceStoreHomePageSection": [
    "MarketplaceStoreHomePageFeaturedSection",
    "MarketplaceStoreHomePageHighlightedSection",
    "MarketplaceStoreHomePageRegularSection"
  ],
  "MarketplaceStorePricingTier": [
    "MarketplaceStorePricingTierAnnual",
    "MarketplaceStorePricingTierMonthly"
  ]
}